import React, { useEffect } from "react";
import { InlineFilters, ListSearchForm, SearchToolbar } from "../../common/DataList";
import useOrganizations from "../../Hooks/useOrganizations/useOrganizations";
import useRecipientStock from "./useRecipientStock";

// Critères sous la recherche libre, toujours visibles. Mêmes clés et mêmes
// valeurs qu'avant (recipient-stocks/search) : orientation parmi France
// Travail et le Département, trois cases à cocher.
export const definitionsFiltresStock = (organizations = []) => [
  {
    name: "orientation",
    label: "Orientation",
    type: "select",
    dataIndex: "slugName",
    firstOptionLabel: "Toutes",
    options: organizations.filter((og) => ["PE", "CD"].includes(og.slugName)),
  },
  { name: "noEmail", label: "Ne possède pas d'adresse email", type: "checkbox" },
  { name: "isEpInProgress", label: "Allocataires avec un EP en cours", type: "checkbox" },
  {
    name: "isReorientationInProgress",
    label: "Allocataires avec une réorientation en cours",
    type: "checkbox",
  },
];

const RecipientStockFilters = () => {
  const {
    recipientStockFilters,
    isLoadingRecipientStock,
    onFiltersChange,
    onSearchRecipientStock,
  } = useRecipientStock();

  const { onGetOrganizations, organizations } = useOrganizations();

  useEffect(() => {
    onGetOrganizations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ListSearchForm onSubmit={() => onSearchRecipientStock()} aria-label="Recherche d'allocataires du stock">
      <SearchToolbar
        id="terms"
        name="terms"
        label="Rechercher"
        value={recipientStockFilters.filters.terms}
        onChange={onFiltersChange}
        placeholder="Nom, prénom, téléphone, NIR, matricule…"
        isLoading={isLoadingRecipientStock}
        inlineFilters={
          <InlineFilters
            definitions={definitionsFiltresStock(organizations)}
            filters={recipientStockFilters.filters}
            onChange={onFiltersChange}
            onSet={(name, value) => onFiltersChange({ target: { name, value } })}
          />
        }
      />
    </ListSearchForm>
  );
};

export default RecipientStockFilters;
